import Vue from "vue";
import Vuex from "vuex";
import dictionary from "./dictionary";
import company from "./company";
import system from "./system";
import environment from "./environment";
import configurationEnvironment from "./configuration-environment";
import user from "./user";
import login from "./login";
import menu from "./menu";
import note from "./note";
import role from "./role";
import permission from "./permission";
import userAccess from "./user-roles";
import groupAccess from "./group-roles";
import group from "./group";
import api from "./apis";
import landingPage from "./landing-page";
import version from "./version";
import userGroup from "./user-group";
import flow from "./flow";
import deploy from "./deploy";
import externalApis from "./external-apis";
import university from "./university";
import quiz from "./quiz";
import templates from "./templates";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    dictionary,
    company,
    system,
    environment,
    configurationEnvironment,
    user,
    login,
    menu,
    note,
    role,
    permission,
    userAccess,
    group,
    groupAccess,
    api,
    landingPage,
    version,
    userGroup,
    flow,
    deploy,
    externalApis,
    university,
    quiz,
    templates,
  },
});
